// Configuration variables for the Lecture Content Platform

const config = {
  // Google API Key
  GOOGLE_API_KEY: 'AIzaSyCjbOxbDxfH2hzVXGstFIFpHs0fOWoEIv4',
  
  // Google Sheets configuration
  SPREADSHEET_ID: '1QG4gts3BHd8dypmxuMiybIhsl8wq_jqjMDfqgZoeaqc',
  SHEET_NAME: 'Sheet1', // Default sheet name in Google Sheets
  SHEET_RANGE: 'Sheet1!A1:K', // Include headers, standard Google Sheet format. Include K for Detailed Notes.
  
  // Default Google Drive folder (in case spreadsheet doesn't specify folder URLs)
  DEFAULT_DRIVE_FOLDER: 'https://drive.google.com/drive/folders/1AHEpgfRSMG9LePP3s-5FDN8WPwSED_MF',
  
  // Content refresh interval (in milliseconds)
  CONTENT_REFRESH_INTERVAL: 24 * 60 * 60 * 1000, // 24 hours
  
  // Default theme colors
  THEME: {
    PRIMARY: '#001f3f',   // Navy Blue
    SECONDARY: '#FFD700', // Gold
    BACKGROUND: '#FFFFFF', // White
    ACCENT: '#388E3C',    // Green
  },
  
  // Organization details
  ORGANIZATION: {
    NAME: 'Dar-e-Zainab (as)',
    LOGO: '/images/logo.jpg',
  },
  
  // API endpoints
  GOOGLE_SHEETS_API: 'https://sheets.googleapis.com/v4/spreadsheets',
  GOOGLE_DRIVE_API: 'https://www.googleapis.com/drive/v3',
  GOOGLE_DOCS_API: 'https://docs.googleapis.com/v1',
  
  // API request settings
  USE_CORS_PROXY: false,
  CORS_PROXY_URL: 'https://cors-anywhere.herokuapp.com/',
};

export default config;
